import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactSectionTitle, ReactProjectCard } from '../shared';
import { images } from '../../constants/images';

// Projects Data: each element is a project object, which contains the project's title, description, image, tech stack, and slug
const projectsData = [
  {
    id: 1,
    title: "FinDocs RAG System",
    description: "Building a Financial Document Q&A System with RAG - My Journey with LangGraph and LLMs",
    imageUrl: images.projects.findocsRag,
    techStack: ["LangChain", "LangGraph", "ChromaDB", "Streamlit", "Python"],
    slug: "findocs-rag-system"
  },
  {
    id: 2,
    title: "PicToMerch: AI-Powered Photo Restyle Web App",
    description: "Turning a user's photo into merch-ready art in one click. ",
    imageUrl: images.projects.pictomercHero,
    techStack: ["React", "Next.js", "Node.js", "Typescript", "Vercel", "Supabase", "OpenAI API"],
    slug: "pic-to-merch-web-app"
  },
  {
    id: 3,
    title: "My Portfolio Website",
    description: "A modern React portfolio with reusable components, Tailwind styling, smooth routing, and accessible mobile navigation.",
    imageUrl: images.projects.portfolioWebsite,
    techStack: ["React", "Node.js", "Tailwind CSS", "LitElement", "Framer Motion"],
    slug: "my-portfolio-website"
  },
  {
    id: 4,
    title: "Foxconn Longhua: P&L Forecasts & Product Mix",
    description: "Cost/profit drivers, model-level unit economics, and 30-day profit forecasts.",
    imageUrl: images.projects.foxconnPL,
    techStack: ["Python", "Prophet", "SARIMA", "Holt-Winters", "TimeGPT"],
    slug: "foxconn-longhua-forecasting"
  },
];

export default function Projects() {
  const navigate = useNavigate();

  const handleProjectClick = (slug) => {
    navigate(`/projects/${slug}`);
  };

  return (
    <section id="projects" className="py-10 sm:py-16 scroll-mt-20">
      <div className="section-container">
        <ReactSectionTitle title="Projects" />
        
        <div className="mx-auto grid max-w-2xl pt-10 grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-3 md:grid-cols-2">
          {projectsData.map((project) => (
            <div 
              key={project.id} 
              onClick={() => handleProjectClick(project.slug)}
              className="cursor-pointer"
            >
              <ReactProjectCard {...project} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 